module.exports = __webpack_public_path__ + "img/yb-logo-url-pos.92581623.svg";